import { CustomEditor } from "../slate-types";

export const withSimpleEditorPlugins = (editor: CustomEditor): CustomEditor => {
  const { isVoid, markableVoid, isInline } = editor;

  editor.isVoid = (element) => {
    return element.type === "mention" ? true : isVoid(element);
  };

  editor.markableVoid = (element) => {
    return element.type === "mention" || markableVoid(element);
  };

  editor.isInline = (element) => {
    return element.type === "mention" ? true : isInline(element);
  };

  return editor;
};
